/* istanbul ignore file */
import { number as codecNumber, oneOf as codecOneOf, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const NewAutoTestTestOutputLimitSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('NEW_AUTO_TEST_TEST_OUTPUT_LIMIT')],
    [
        'value',
        /* #__PURE__ */ parsers.maybeNull(
        /* #__PURE__ */ codecOneOf([codecNumber, codecString])),
    ],
]);
export class NewAutoTestTestOutputLimitSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return NewAutoTestTestOutputLimitSettingParser.decode(input).map(res => new NewAutoTestTestOutputLimitSetting(res));
    }
    static unsafeDecode(input) {
        return NewAutoTestTestOutputLimitSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NewAutoTestTestOutputLimitSettingParser.encode(data);
    }
    static schema() {
        return NewAutoTestTestOutputLimitSettingParser.schema();
    }
}
